import {Component, OnInit, ViewChild, inject} from '@angular/core';
import {
  FilteringLogic,
  IgxPickerClearComponent, IgxStringFilteringOperand, SortingDirection, Transaction, TransactionType
} from '@infragistics/igniteui-angular/core';
import { IgxButtonDirective, IgxButtonModule, IgxFocusDirective, IgxLayoutModule, IgxRippleDirective, IgxRippleModule, IgxTextSelectionDirective } from '@infragistics/igniteui-angular/directives';
import { IGridEditEventArgs, IgxColumnComponent, RowType } from '@infragistics/igniteui-angular/grids/core';
import { IGX_DATE_PICKER_DIRECTIVES, IgxDatePickerComponent } from '@infragistics/igniteui-angular/date-picker';
import { IGX_GRID_DIRECTIVES, IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular/grids/grid';
import {
  IGX_INPUT_GROUP_DIRECTIVES,
  IgxInputDirective,
  IgxInputGroupComponent, IgxSuffixDirective
} from '@infragistics/igniteui-angular/input-group';
import { IGX_NAVIGATION_DRAWER_DIRECTIVES, IgxNavigationDrawerComponent, IgxNavigationDrawerModule } from '@infragistics/igniteui-angular/navigation-drawer';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import {IGX_SELECT_DIRECTIVES, IgxSelectComponent, IgxSelectItemComponent} from '@infragistics/igniteui-angular/select';
import { IGX_CARD_DIRECTIVES, IgxCardModule } from '@infragistics/igniteui-angular/card';
import { IGX_DIALOG_DIRECTIVES, IgxDialogModule } from '@infragistics/igniteui-angular/dialog';
import { IGX_ACTION_STRIP_DIRECTIVES, IgxActionStripModule } from '@infragistics/igniteui-angular/action-strip';
import {MasOpcionesGridComponent} from '../../controles/mas-opciones-grid/mas-opciones-grid.component';
import {ClsConfig} from '../../../../util/cls-config';
import {EnumMasOpciones} from '../../../../core/models/enum/enum-mas-opciones';
import {ClsUtil} from '../../../../util/cls-util';
import {ClsObjCatalogoPresupuestosGenerales} from '../../../../clases-pu/cls-obj-catalogo-presupuestos-generales';
import {AppPresupuestosService} from '../../../../core/services/app-presupuestos.service';
import {AppInfoService} from '../../../../core/services/app-info.service';
import {ClsCatalogoPresupuestos, ClsUsuarioCompartir} from '../../../../core/models/cls-presupuestos';
import {ClsObjGenerico} from '../../../../clases-pu/util/cls-obj-generico';
import {ClsEnviarCorreo} from '../../../../core/models/cls-envio-correo';
import {FiltroGeneralComponent} from '../../controles/filtro-general/filtro-general.component';
import {VtnGenericaComponent} from '../vtn-generica/vtn-generica.component';
import {ClsObjCopiado} from '../../../../clases-pu/01-presupuesto/copiado/cls-obj-copiado';
import {EnumParaOrg, EnumParaUsu} from '../../../../core/models/enum/enum-parametros';
import {ClsParametro} from '../../../../core/models/cls-parametros';
import {EnumTipoParametro} from '../../../../core/models/enum/enum-tipo-parametro';
import {TranslateModule} from '@ngx-translate/core';
import {DatePipe} from '@angular/common';
import {PasteHandlerNeodataDirective} from '../../../../core/directivas/paste-handler-neodata.directive';
import {FormsModule} from '@angular/forms';
import {TipoMensajesService} from "../../../../core/services/tipo-mensajes.service";
import {SummaryPipeNeoPipe} from "../../../../core/pipes/summary-pipe-neo.pipe";
import {ShortcutsBusService} from "../../../../core/services/shortcuts-bus.service";
import {Subscription} from "rxjs";
import {EnumShortCuts} from "../../../../core/models/enum/enum-short-cuts";

@Component({
  selector: 'app-compartir-presupuesto',
  templateUrl: './compartir-presupuesto.component.html',
  styleUrls: ['./compartir-presupuesto.component.scss'],
  imports: [
    IgxCardModule,
    IGX_CARD_DIRECTIVES,
    IGX_SELECT_DIRECTIVES,
    TranslateModule,
    FormsModule,
    IgxButtonModule,
    IgxButtonDirective,
    IgxRippleModule,
    IgxRippleDirective,
    IGX_DATE_PICKER_DIRECTIVES,
    IGX_INPUT_GROUP_DIRECTIVES,
    IgxTextSelectionDirective,
    IgxFocusDirective,
    IgxLayoutModule,
    IgxNavigationDrawerModule,
    IGX_NAVIGATION_DRAWER_DIRECTIVES,
    IgxGridModule,
    IGX_GRID_DIRECTIVES,
    FiltroGeneralComponent,
    MasOpcionesGridComponent,
    IgxIconComponent,
    IgxDialogModule,
    IGX_DIALOG_DIRECTIVES,
    PasteHandlerNeodataDirective,
    DatePipe,
    IgxActionStripModule,
    IGX_ACTION_STRIP_DIRECTIVES,
    SummaryPipeNeoPipe,
    IgxSelectComponent,
    IgxSelectItemComponent,
    IgxDatePickerComponent,
    IgxPickerClearComponent,
    IgxInputGroupComponent,
    IgxSuffixDirective,
  ]
})
export class CompartirPresupuestoComponent extends ClsConfig implements OnInit {
  private infPpto = inject(AppPresupuestosService);
  private infApp = inject(AppInfoService);
  private tipoMsg = inject(TipoMensajesService);
  public shortcutsBus = inject(ShortcutsBusService);

  @ViewChild('gridCompartirPresupuesto', {read: IgxGridComponent, static: true})
  public gridCompartirPresupuesto: IgxGridComponent;
  @ViewChild('masOpciones', {read: MasOpcionesGridComponent, static: true})
  public masOpciones: MasOpcionesGridComponent;
  @ViewChild('filtroGeneral', {read: FiltroGeneralComponent, static: true})
  public filtroGeneral: FiltroGeneralComponent;

  @ViewChild('dateFechaVigencia', {read: IgxDatePickerComponent, static: true})
  public dateFechaVigencia: IgxDatePickerComponent;
  @ViewChild('diasCalcular', {read: IgxInputDirective, static: true})
  public diasCalcular: IgxInputDirective;

  @ViewChild('gridUsuariosOrg', {read: IgxGridComponent})
  public gridUsuariosOrg: IgxGridComponent;
  @ViewChild('filtroGeneralUsuOrg', {read: FiltroGeneralComponent})
  public filtroGeneralUsuOrg: FiltroGeneralComponent;
  @ViewChild('masOpcionesUsuOrg', {read: MasOpcionesGridComponent})
  public masOpcionesUsuOrg: MasOpcionesGridComponent;
  @ViewChild('drawer', {read: IgxNavigationDrawerComponent})
  public drawer: IgxNavigationDrawerComponent;
  @ViewChild('btnMenuCorreos', {read: IgxButtonDirective})
  public btnMenuCorreos: IgxButtonDirective;

  public pptoSeleccionado: ClsCatalogoPresupuestos;
  public dataUsuariosCompartidos: ClsUsuarioCompartir[] = [];
  public mObjCatalogoPptosGrals: ClsObjCatalogoPresupuestosGenerales = new ClsObjCatalogoPresupuestosGenerales();
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();
  private mObjCopiado: ClsObjCopiado = new ClsObjCopiado();
  public nivelAccesso: string[];
  private isAddRow = false;
  public selected: string;
  public soloAdminVerCorreosOrg: boolean;

  public backgroundClasses = {
    highlighted: (rowData: any, columnKey: any) => {
      if (columnKey === 'EmailUsuarioCompartido') {
        return rowData.EmailUsuarioCompartido;
      }
    }
  };
  // mostrar actionStrip
  public showActionStrip = true;
  // ventana
  public vtnGenerico: VtnGenericaComponent;

  private sub!: Subscription;
  constructor() {
    super();
  }

  ngOnInit(): void {
    this.gridCompartirPresupuesto.data = [];
    this.sub = this.shortcutsBus.action$.subscribe(async (action: string) => {
      switch (action) {
        case EnumShortCuts.DESHACER:
          this.undo();
          break;
        case EnumShortCuts.REHACER:
          this.redo();
          break;
        case EnumShortCuts.GUARDAR:
          await this.commit();
          break;
        case EnumShortCuts.DESCARTAR:
          this.discard();
          break;
      }
    });
    this.vtnGenerico.evtCerrarVnt.subscribe((seCerro: boolean) => {
      if (seCerro) {
        this.sub?.unsubscribe();
        this.close();
      }
    })
  }

  public async open() {
    this.nivelAccesso = [];
    this.nivelAccesso.push(this.mObjCatalogoPptosGrals.getTranslationsNivelAcceso('MENSAJES.GRALS.LECTURA'));
    this.nivelAccesso.push(this.mObjCatalogoPptosGrals.getTranslationsNivelAcceso('MENSAJES.GRALS.ESCRITURA'));
    this.filtroGeneral.descripcionLabel = 'MENSAJES.GRALS.ETIQUETA_FILTRO_GRAL';
    this.selected = this.nivelAccesso[1];
    await this.cargarPresupuestosCompartidos();
  }

  public close() {
    this.vtnGenerico.close();
  }

  public agregarCorreos(textArea: any) {
    try {
      this.procesarCorreos(textArea.value);
      textArea.value = '';
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message);
    }
  }

  private procesarCorreos(cadenaCorreos: string) {
    let splitCorreos: string[] = [];
    try {
      cadenaCorreos = cadenaCorreos.toLowerCase().trim();
      if (ClsUtil.esNulo(cadenaCorreos)) {
        throw new Error(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.COMPARTIR_PPTO.COL_CORREO')));
      }
      // quitamos espacios, enter, tab
      cadenaCorreos.replace(/[\t\n\r]/gm, ',').split(',').forEach(value => {
        if (!ClsUtil.esNulo(value)) {
          splitCorreos.push(value.trim().replace(/[\t\n\r]/gm, ''));
        }
      });
      // quitamos los correos duplicados
      splitCorreos = [...new Set(splitCorreos)];
      // validar que los correos sean validos
      splitCorreos.forEach((correo, index) => {
        correo = correo.trim();
        if (!correo.match(this.gRegexCorreos)) {
          const mensaje: string = this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.CORREO_NO_VALIDO');
          throw new Error(mensaje.replace('{0}', correo));
        }
        if (this.gridCompartirPresupuesto.groupingFlatResult.findIndex(emailUsuarioCompartido => emailUsuarioCompartido.EmailUsuarioCompartido === correo) !== -1) {
          throw new Error(this.mObjGenerico.getTranslationsAlertRegistroExistente(correo));
        }
      });
      //  agregar correos al grid
      this.gridCompartirPresupuesto.rowEditable = true;
      splitCorreos.forEach(correo => {
        const usuario: ClsUsuarioCompartir = {
          IdPresupuestoXUsuario: ClsUtil.generarID(),
          IdPresupuesto: this.pptoSeleccionado.IdPresupuesto.toString(),
          EmailUsuarioCompartido: correo.trim(),
          FechaVigencia: new Date(this.dateFechaVigencia.value),
          NivelAccesoS: ClsUtil.esNulo(this.dateFechaVigencia.value) ? this.mObjCatalogoPptosGrals.getTranslationsNivelAcceso('MENSAJES.GRALS.LECTURA') : this.selected
        };
        this.gridCompartirPresupuesto.addRow(usuario);
      });
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async commit() {
    const listaCorreosNoExistentes: ErroresCorreos[] = [];
    const idsNuevos: NuevosCorreos[] = [];
    try {
      this.tipoMsg.mostrarMasMsgsCustomizado('TITULOS.COMPARTIR_PPTO');
      const transactionsData: Transaction[] = this.gridCompartirPresupuesto.transactions.getAggregatedChanges(true);
      for (const transaction of transactionsData) {
        const usuarioCompartido: ClsUsuarioCompartir = transaction.newValue;
        switch (transaction.type) {
          case TransactionType.ADD:
            usuarioCompartido.IdPresupuestoXUsuario = ClsUtil.parseJSONBig(0);
            usuarioCompartido.NivelAcceso = usuarioCompartido.NivelAccesoS === this.mObjCatalogoPptosGrals.getTranslationsNivelAcceso('MENSAJES.GRALS.LECTURA') ? 1 : 2;
            this.tipoMsg.actualizarMensaje2(this.mObjCatalogoPptosGrals.getTranslationsWaitGuardarUsuariosCompartidos(usuarioCompartido.EmailUsuarioCompartido));
            try {
              const respuesta: bigint = await this.mObjCatalogoPptosGrals.compartirPresupuesto(usuarioCompartido);
              idsNuevos.push({Correo: usuarioCompartido.EmailUsuarioCompartido, Id: respuesta.toString()});
              this.tipoMsg.actualizarMensaje2(this.mObjGenerico.getTranslationsSubject('MENSAJES.WAIT.ENVIAR_CORREO').replace('{0}', usuarioCompartido.EmailUsuarioCompartido));
              await this.enviarPorCorreo(TipoAccion.ADD, usuarioCompartido);
            } catch (e) {
              listaCorreosNoExistentes.push({
                Correo: usuarioCompartido.EmailUsuarioCompartido,
                MensajeError: e.message
              });
            }
            break;
          case TransactionType.UPDATE:
            usuarioCompartido.NivelAcceso = usuarioCompartido.NivelAccesoS === this.mObjCatalogoPptosGrals.getTranslationsNivelAcceso('MENSAJES.GRALS.LECTURA') ? 1 : 2;
            this.tipoMsg.actualizarMensaje2(this.mObjCatalogoPptosGrals.getTranslationsWaitActualizarUsuariosCompartidos(usuarioCompartido.EmailUsuarioCompartido));
            try {
              await this.mObjCatalogoPptosGrals.compartirPresupuesto(usuarioCompartido);
              this.tipoMsg.actualizarMensaje2(this.mObjGenerico.getTranslationsSubject('MENSAJES.WAIT.ENVIAR_CORREO').replace('{0}', usuarioCompartido.EmailUsuarioCompartido));
              await this.enviarPorCorreo(TipoAccion.UPDATE, usuarioCompartido);
            } catch (e) {
              listaCorreosNoExistentes.push({
                Correo: usuarioCompartido.EmailUsuarioCompartido,
                MensajeError: e.message
              });
            }
            break;
          case TransactionType.DELETE:
            this.tipoMsg.actualizarMensaje2(this.mObjCatalogoPptosGrals.getTranslationsWaitBorrarUsuariosCompartidos(usuarioCompartido.EmailUsuarioCompartido));
            try {
              await this.mObjCatalogoPptosGrals.borrarUsuariosCompartidosPresupuesto(usuarioCompartido.IdPresupuestoXUsuario);
              this.tipoMsg.actualizarMensaje2(this.mObjGenerico.getTranslationsSubject('MENSAJES.WAIT.ENVIAR_CORREO').replace('{0}', usuarioCompartido.EmailUsuarioCompartido));
              await this.enviarPorCorreo(TipoAccion.DELETE, usuarioCompartido);
            } catch (e) {
              listaCorreosNoExistentes.push({
                Correo: usuarioCompartido.EmailUsuarioCompartido,
                MensajeError: e.message
              });
            }
            break;
        }
      }

      // hacemos commit(guardar cambios)
      this.gridCompartirPresupuesto.transactions.commit(this.gridCompartirPresupuesto.data);
      // quitamos los registros que no fueron procesados
      listaCorreosNoExistentes.forEach(value => {
        const index: number = this.gridCompartirPresupuesto.data.findIndex(correo => correo.EmailUsuarioCompartido === value.Correo);
        if (index !== -1) {
          this.gridCompartirPresupuesto.data.splice(index, 1);
        }
      });
      // asignamos IDs a los correos nuevos para que sean modificados posteriormente
      idsNuevos.forEach(value => {
        const registro: ClsUsuarioCompartir = this.gridCompartirPresupuesto.data.find(correo => correo.EmailUsuarioCompartido === value.Correo);
        registro.IdPresupuestoXUsuario = value.Id;
      });
      this.gridCompartirPresupuesto.rowEditable = this.acitvarRowEditable();
      this.gridCompartirPresupuesto.deselectAllRows();
      const filtroCiudad: ClsParametro = this.infPpto.parametrosUsuario.find(param => param.Parametro === EnumParaUsu.DIASACOMPARTIRPPTO);
      filtroCiudad.Valor = this.diasCalcular.value.toString();
      await this.mObjGenerico.registraActualizaNParametros(this.infApp.usuarioLogeado.idUsuario, EnumTipoParametro.Usuario, [filtroCiudad]);
      this.tipoMsg.cerrarMasMsgsCustomizado();
      // mandamos detalles de los correos no procesados
      if (listaCorreosNoExistentes.length > 0) {
        let msj = '';
        let mensajeError: string;
        listaCorreosNoExistentes.forEach(value => {
          msj += `${value.Correo}: ${value.MensajeError.replace('\n\nPuNube+', '')}<br>`;
        });
        mensajeError = this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.ERROR_COMPARTIR_PPTO');
        this.tipoMsg.mostrarMsg(mensajeError.replace('{0}', `<br> ${msj}`));
      }
    } catch (e) {
      this.tipoMsg.cerrarMasMsgsCustomizado();
      this.tipoMsg.mostrarMsg(e.message);
    }
  }

  public async obtenerCorreosOrganizacion() {
    this.gridUsuariosOrg.data = [];
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.GET_CORREOS_ORGANIZACION');
      this.gridUsuariosOrg.sortingExpressions = [{fieldName: 'emailusuario', dir: SortingDirection.Asc}];
      this.gridUsuariosOrg.data = await this.mObjGenerico.listadoCorreosPorOrganizacion(false);
      this.drawer.open();
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public addMiListaCompartidos() {
    let correos = '';
    const selectedRows: string[] = [];
    try {
      if (this.gridUsuariosOrg.selectedRows.length === 0) {
        throw new Error('MENSAJES.ALERT.SELECCIONAR_REGISTRO2');
      }
      // quitar correos existentes en mi lista de compartidos
      this.gridUsuariosOrg.selectedRows.forEach(correo => {
        if (this.gridCompartirPresupuesto.groupingFlatResult.filter(item => item.EmailUsuarioCompartido === correo).length === 0) {
          selectedRows.push(correo);
        }
      });
      selectedRows.forEach(correo => {
        if (correos.length > 0) {
          correos += ',';
        }
        correos += correo;
      });
      if (selectedRows.length > 0) {
        this.procesarCorreos(correos);
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  private acitvarRowEditable(): boolean {
    return this.gridCompartirPresupuesto.data.length > 0;
  }

  public get hasTransactions(): boolean {
    return this.gridCompartirPresupuesto.transactions.getAggregatedChanges(false).length > 0;
  }

  public undo() {
    this.gridCompartirPresupuesto.transactions.undo();
  }

  public redo() {
    this.gridCompartirPresupuesto.transactions.redo();
  }

  public discard() {
    this.tipoMsg.mostrarQuestion((resp: boolean) => {
      if (resp) {
        this.gridCompartirPresupuesto.transactions.clear();
        this.gridCompartirPresupuesto.rowEditable = this.acitvarRowEditable();
      }
    }, 'MENSAJES.QUESTION.CANCELAR_CAMBIOS');
  }

  public async datosPegadosDesdeExcel(datosPegado: any[]) {
    try {
      if (!ClsUtil.esNulo(datosPegado) && datosPegado.length > 0) {
        const colCorreo: string = this.mObjGenerico.getTranslationsSubject('GRIDS.COMPARTIR_PPTO.COL_CORREO');
        this.mObjCopiado.columnasRequeridas = [colCorreo];
        if (this.mObjCopiado.validarCamposRequeridos(datosPegado)) {
          const datos: any[] = this.mObjCopiado.procesarDatos(datosPegado, true);
          let correos = '';
          datos.forEach(value => {
            const valorCodigo: string = value[this.mObjGenerico.getTranslationsSubject('GRIDS.COMPARTIR_PPTO.COL_CORREO')];
            if (correos.length > 0) {
              correos += ',';
            }
            correos += valorCodigo;
          });
          this.procesarCorreos(correos);
        }
      } else {
        this.tipoMsg.mostrarMsg('MENSAJES.GRALS.DATOS_SIN_PEGAR');
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message);
    }
  }

  public clearInput() {
    this.filtroGeneral.input.value = '';
    this.gridCompartirPresupuesto.clearFilter();
    this.gridCompartirPresupuesto.rowEditable = this.acitvarRowEditable();
  }

  public filterInput(filtro: string) {
    this.gridCompartirPresupuesto.filteringLogic = FilteringLogic.Or;
    this.gridCompartirPresupuesto.filterGlobal(filtro, IgxStringFilteringOperand.instance().condition('contains'));
    this.gridCompartirPresupuesto.rowEditable = this.acitvarRowEditable();
  }

  public filterInputUsuOrg(filtro: string) {
    this.gridUsuariosOrg.filteringLogic = FilteringLogic.Or;
    this.gridUsuariosOrg.filterGlobal(filtro, IgxStringFilteringOperand.instance().condition('contains'));
  }

  public clearInputUsuOrg() {
    this.filtroGeneralUsuOrg.input.value = '';
    this.gridUsuariosOrg.clearFilter();
  }

  public rowEditEnter(evt: IGridEditEventArgs) {
    this.showActionStrip = false;
  }

  public rowEditExit() {
    this.showActionStrip = true;
  }

  public cellEditEnter(evt: IGridEditEventArgs) {
    if (!this.isAddRow) {
      if (evt.column.field === 'EmailUsuarioCompartido') {
        evt.cancel = true;
      }
    }
  }

  public onColumnInit(col: IgxColumnComponent) {
    col.cellClasses = this.backgroundClasses;
  }

  public async cargarPresupuestosCompartidos() {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.GET_USERS_COMPARTIDO');
      this.dataUsuariosCompartidos = [];
      this.diasCalcular.value = Number(this.infPpto.parametrosUsuario.find(param => param.Parametro === EnumParaUsu.DIASACOMPARTIRPPTO).Valor);
      this.calcularVigencia(this.diasCalcular.value);
      await this.validarMostrarComponenteListaCorreo();
      const respuesta: ClsUsuarioCompartir[] = await this.mObjCatalogoPptosGrals.obtenerUsuariosCompartidosPresupuesto(this.pptoSeleccionado.IdPresupuesto);
      respuesta.forEach(usuario => {
        const usuario2: ClsUsuarioCompartir = {
          IdPresupuestoXUsuario: usuario.IdPresupuestoXUsuario.toString(),
          IdPresupuesto: usuario.IdPresupuesto.toString(),
          EmailUsuarioCompartido: usuario.EmailUsuarioCompartido,
          FechaVigencia: this.calcularVigencia(ClsUtil.numberX(this.diasCalcular.value)),
          NivelAccesoS: usuario.NivelAcceso === 1 ? this.mObjCatalogoPptosGrals.getTranslationsNivelAcceso('MENSAJES.GRALS.LECTURA') : this.mObjCatalogoPptosGrals.getTranslationsNivelAcceso('MENSAJES.GRALS.ESCRITURA')
        };
        this.dataUsuariosCompartidos.push(usuario2);
      });
      this.gridCompartirPresupuesto.sortingExpressions = [{
        fieldName: 'EmailUsuarioCompartido',
        dir: SortingDirection.Asc
      }];
      this.gridCompartirPresupuesto.data = this.dataUsuariosCompartidos;
      this.gridCompartirPresupuesto.rowEditable = this.acitvarRowEditable();
      this.vtnGenerico.open(605, 1150, 'TITULOS.COMPARTIR_PPTO', 'share');
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  private async validarMostrarComponenteListaCorreo() {
    const adminVerCorreosOrg: ClsParametro[] = await this.mObjGenerico.obtenerNParametros(this.infPpto.organizacion.IdOrganizacion, EnumTipoParametro.Organizacion, [{Parametro: EnumParaOrg.SOLOADMINVERCORREOSORG}]);
    this.soloAdminVerCorreosOrg = Boolean(Number(adminVerCorreosOrg[0].Valor));
    if ((this.soloAdminVerCorreosOrg && this.infApp.usuarioLogeado.admin) || !this.soloAdminVerCorreosOrg) {
      this.btnMenuCorreos.element.nativeElement.hidden = false;
      this.drawer.open();
    } else {
      this.btnMenuCorreos.element.nativeElement.hidden = true;
      this.drawer.close();
    }
  }

  private async enviarPorCorreo(tipo: TipoAccion, data: ClsUsuarioCompartir) {
    let clsECorreo: ClsEnviarCorreo;
    let htmlLocal: string;
    let asunto: string;
    const acceso: string = data.NivelAccesoS;
    const currentLang: string = this.infApp.translate.getCurrentLang();
    let titulo: string;
    let iconoCorreo: string;
    try {
      htmlLocal = await this.mObjGenerico.obtenerPlantillaParaCorreo(`../assets/enviocorreo/${currentLang === 'es' ? 'ES' : 'EN'}/NewPptoCompartido.html`);
      switch (tipo) {
        case TipoAccion.ADD:
          titulo = this.mObjGenerico.getTranslationsSubject('MENSAJES.GRALS.SUBJECT2');
          iconoCorreo = 'share-check.png';
          asunto = titulo;
          break;
        case TipoAccion.UPDATE:
          titulo = this.mObjGenerico.getTranslationsSubject('MENSAJES.GRALS.SUBJECT3');
          iconoCorreo = 'share-edit.png';
          asunto = titulo;
          break;
        case TipoAccion.DELETE:
          titulo = this.mObjGenerico.getTranslationsSubject('MENSAJES.GRALS.SUBJECT4');
          iconoCorreo = 'share-delete.png';
          asunto = titulo;
          break;
      }
      htmlLocal = htmlLocal.replace('{0}', titulo);
      htmlLocal = htmlLocal.replace('{4}', `https://storage.googleapis.com/correos/PUNUBE%2B/${iconoCorreo}`);
      htmlLocal = htmlLocal.replace('{5}', ClsUtil.getShareActionColor(tipo));
      htmlLocal = htmlLocal.replace('{1}', `${this.pptoSeleccionado.CodigoPresupuesto} ${this.pptoSeleccionado.NombrePresupuesto}`);
      htmlLocal = htmlLocal.replace('{2}', acceso);
      htmlLocal = htmlLocal.replace('{3}', `${ClsUtil.formatoFechaManualPipe(data.FechaVigencia, 'dd/MM/yyyy')}`);
      clsECorreo = this.mObjGenerico.crearObjParaEnviarCorreo(this.infApp.usuarioLogeado.email, data.EmailUsuarioCompartido, asunto, htmlLocal, []);
      await this.mObjGenerico.enviarPorCorreo(clsECorreo);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async onSelectionDropDown(opcion: string, gridUsuOrg: boolean) {
    try {
      switch (opcion) {
        case EnumMasOpciones.Actualizar:
          (gridUsuOrg) ? await this.obtenerCorreosOrganizacion() : await this.cargarPresupuestosCompartidos();
          break;
        case EnumMasOpciones.LimpiarFiltroColumnas:
          (gridUsuOrg) ? this.clearInputUsuOrg() : this.clearInput();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public accionStripRowBtn(rowContext: RowType, indexBtn: number) {
    try {
      switch (indexBtn) {
        case 1:
          this.beginAddRowByIndexNeo(this.gridCompartirPresupuesto, rowContext.index);
          break;
        case 2:
          rowContext.delete();
          this.gridCompartirPresupuesto.rowEditable = this.acitvarRowEditable();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public asignarPermiso() {
    const rowSeleccionados: any[] = this.gridCompartirPresupuesto.selectedRows;
    if (rowSeleccionados.length === 0) {
      this.gridCompartirPresupuesto.dataView.forEach((value: any, index: number) => {
        const editTransaction: Transaction = {
          id: this.gridCompartirPresupuesto.dataView[index].IdPresupuestoXUsuario,
          type: TransactionType.UPDATE,
          newValue: {NivelAccesoS: this.selected}
        };
        this.gridCompartirPresupuesto.transactions.add(editTransaction, this.gridCompartirPresupuesto.dataView[index]);
      });
    } else {
      for (const rowsKey of rowSeleccionados) {
        const rowData: ClsUsuarioCompartir = this.gridCompartirPresupuesto.getRowData(rowsKey);
        const editTransaction: Transaction = {
          id: rowData.IdPresupuestoXUsuario,
          type: TransactionType.UPDATE,
          newValue: {NivelAccesoS: this.selected}
        };
        this.gridCompartirPresupuesto.transactions.add(editTransaction, rowData);
      }
    }
  }

  public asignarVigencia() {
    const rowSeleccionados: any[] = this.gridCompartirPresupuesto.selectedRows;
    if (rowSeleccionados.length === 0) {
      this.gridCompartirPresupuesto.dataView.forEach((value: any, index: number) => {
        const editTransaction: Transaction = {
          id: this.gridCompartirPresupuesto.dataView[index].IdPresupuestoXUsuario,
          type: TransactionType.UPDATE,
          newValue: {FechaVigencia: new Date(this.dateFechaVigencia.value)}
        };
        this.gridCompartirPresupuesto.transactions.add(editTransaction, this.gridCompartirPresupuesto.dataView[index]);
      });
    } else {
      for (const rowsKey of rowSeleccionados) {
        const rowData: ClsUsuarioCompartir = this.gridCompartirPresupuesto.getRowData(rowsKey);
        const editTransaction: Transaction = {
          id: rowData.IdPresupuestoXUsuario,
          type: TransactionType.UPDATE,
          newValue: {FechaVigencia: new Date(this.dateFechaVigencia.value)}
        };
        this.gridCompartirPresupuesto.transactions.add(editTransaction, rowData);
      }
    }
  }

  public calcularVigencia(dias: number): Date {
    const fechaDia: Date = new Date();
    const fechaCalculada: Date = new Date(fechaDia.getFullYear(), fechaDia.getMonth(), fechaDia.getDate() + ClsUtil.numberX(dias), fechaDia.getHours(), fechaDia.getMinutes(), fechaDia.getSeconds(), fechaDia.getMilliseconds());
    this.dateFechaVigencia.value = fechaCalculada;
    return fechaCalculada;
  }

  public obtenerDias(evt: any) {
    this.diasCalcular.value = ClsUtil.obtenerNumDiferenciaDiaEntreFecha2(evt.owner.dateValue);
  }
}

export enum TipoAccion {
  ADD = 'add',
  DELETE = 'delete',
  UPDATE = 'update'
}

export class ErroresCorreos {
  Correo: string;
  MensajeError: string;
}

export class NuevosCorreos {
  Correo: string;
  Id: string;
}
